import styled from 'styled-components/macro';

import * as colors from 'components/common/colorConstants';

export const Inbox = styled.div`
  justify-content: flex-start;
  display: flex;
  flex-direction: column;
  overflow: visible;
`;
Inbox.displayName = 'Inbox';

export const QueueContainerWrapper = styled.div`
  height: 100%;
`;

export const QueueContainerRow = styled.div`
  flex: 1;
  height: 100%;
  background-color: ${colors.inboxListBg};
  scrollbar-color: var(--queue-scrollbar-color);
  /* NOTE(vlad|SPD-14096|2026-02-12): Only show scroll when there are tickets to scroll through */
  overflow-y: ${(props) => (props.$hasTickets ? 'auto' : 'hidden')};
`;

export const InboxTabPickerWrapper = styled.div`
  border-bottom: 1px solid ${colors.lightGray21};
`;
